export default __webpack_public_path__ + "static/ui-time-off-ac7684962b55811ae0c0f55b6786e588.png";